export default __webpack_public_path__ + "static/media/dislike.ce168c7a.svg";